exports.onClientEntry = () => {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }
}

// Prevent Gatsby from restoring a previous visit's scroll position.
// Returning [0, 0] is treated as truthy and still restores saved Y.
exports.shouldUpdateScroll = () => false

const applyRoutePosition = (location) => {
  if (location?.hash) {
    const id = decodeURI(location.hash.slice(1))
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView()
      return
    }
  }

  window.scrollTo(0, 0)
}

const scrollToRoutePosition = (location) => {
  if (typeof window === "undefined") return

  // Position immediately so there's no flash of the old scroll offset...
  applyRoutePosition(location)

  // ...then again after the frame, because onRouteUpdate runs during the
  // commit and several things can still move the page afterwards. Chiefly
  // Gatsby focuses #gatsby-focus-wrapper on route change for a11y, and
  // focusing an element scrolls it into view: the hero's top margin
  // collapses out of the page wrapper (the fixed header adds no height, so
  // the hero is the first in-flow child), leaving the wrapper's box to
  // start below the header - so that focus scroll parks the hero's top
  // behind the header. Running last wins, whatever did the scrolling.
  requestAnimationFrame(() => requestAnimationFrame(() => applyRoutePosition(location)))
}

exports.onRouteUpdate = ({ location }) => {
  scrollToRoutePosition(location)
}

exports.onInitialClientRender = () => {
  scrollToRoutePosition(window.location)
}
